import React, { Component, PropTypes } from 'react';
import { StoreOverviewActions } from 'actions';
import Ozitor from 'components/Widgets/Ozitor';
import { Colors } from 'Css';
import ColorChooser from '../ColorChooser';
import SizeChooser from '../SizeChooser';

const css = oxygenCss({
  editorWrapper: {
    position: 'relative',
    backgroundColor: Colors.fullWhite
  },
  half: {
    width: 96,
    margin: 'auto'
  }
});

class StoreTextModuleEditor extends Component {
  static propTypes = {
    id: PropTypes.string,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    size: PropTypes.number,
    __html: PropTypes.string
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  handleChange = __html => {
    const { id } = this.props;
    StoreOverviewActions.updateModuleDebounced(id, {
      __html
    });
  };

  chooseColor = newColor => {
    const { id, color } = this.props;
    StoreOverviewActions.updateModule(id, {
      color: color === newColor ? null : newColor
    });
  };

  chooseBackgroundColor = newColor => {
    const { id, backgroundColor } = this.props;
    StoreOverviewActions.updateModule(id, {
      backgroundColor: backgroundColor === newColor ? null : newColor
    });
  };

  chooseSize = size => {
    const { id } = this.props;
    StoreOverviewActions.updateModule(id, {
      size
    });
  };

  render() {
    const { __html, color, size, backgroundColor } = this.props;
    const { getIntlMessage } = this.context;
    return (
      <div className={css.root}>
        <div className={css.half}>
          <SizeChooser
            sizes={[0, 1, 2, 3]}
            onChange={this.chooseSize}
            selected={size}
            title={getIntlMessage('store.size')}
          />
        </div>
        <ColorChooser
          onChange={this.chooseBackgroundColor}
          title={getIntlMessage('store.backgroundColor')}
          selected={backgroundColor}
        />
        <ColorChooser
          onChange={this.chooseColor}
          title={getIntlMessage('store.Color')}
          selected={color}
        />
        <div className={css.editorWrapper}>
          <Ozitor
            editable
            onChange={this.handleChange}
            defaultContent={__html}
          />
        </div>
      </div>
    );
  }
}

export default StoreTextModuleEditor;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/Modules/StoreTextModuleEditor.js